import EfSection from '@elem/ui/ef-section';
import EfImg from '@elem/ui/ef-img';
import CompA from './CompA';
import CompB from './CompB';
import CompC from './CompC';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.OtherC');
    return (
        <div className={styles.TheComp}>
            <EfSection title={t('title')} desc={t('desc')} />
            <div className="ef-container bg-content2">
                <EfImg
                    className="bg"
                    pc="https://websiteoss.ecoflow.com/upload/image/1725592496592/pc_bg_earth.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1725594091880/m_bg_earth.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1725594091880/m_bg_earth.jpg"
                />
                <CompA />
                <CompB />
                <CompC />
            </div>
        </div>
    );
}
